import { useCallback } from 'react';
import { useFlagsService } from '@atlassian/jira-flags';
import type { MessageDescriptorV2 } from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from './messages';

type ErrorMessages = {
	errorTitle: MessageDescriptorV2;
	errorDescription: MessageDescriptorV2;
};

const useSaveFailedFlag = () => {
	const { showFlag } = useFlagsService();

	return useCallback(
		(featureName: string, value: boolean, errorMessages?: ErrorMessages) => {
			const errorTitle = errorMessages?.errorTitle || messages.saveErrorTitle;
			const errorDescription = errorMessages?.errorDescription || messages.saveErrorDescription;
			const feature = featureName.toLowerCase();

			showFlag({
				type: 'error',
				isAutoDismiss: true,
				title: [errorTitle, { feature, value }],
				description: errorDescription,
				actions: [
					{
						content: messages.refreshAction,
						onClick: () => {
							window.location.reload();
						},
					},
				],
			});
		},
		[showFlag],
	);
};

export default useSaveFailedFlag;
